import axios from "../Axios/Default";
import { handleResponse } from "../Utils/Utils";
//test
export const getSubSubcategoryAll = (_params, onSuccess, onError) => {
  const response = axios.get("v1/admin/sub-subcategory", { params: _params });
  return handleResponse(response, onSuccess, onError);
};

export const getSubSubcategoryById = (id, onSuccess, onError) => {
  const response = axios.get(`v1/admin/sub-subcategory/${id}`);
  return handleResponse(response, onSuccess, onError);
};

export const createSubSubcategory = (payload, onSuccess, onError) => {
  const response = axios.post(`v1/admin/sub-subcategory`, payload);
  return handleResponse(response, onSuccess, onError);
};

export const updateSubSubcategory = (id, payload, onSuccess, onError) => {
  const response = axios.put(`v1/admin/sub-subcategory/${id}`, payload);
  return handleResponse(response, onSuccess, onError);
};

export const softDeleteSubSubcategory = (id, payload, onSuccess, onError) => {
  const response = axios.put(`v1/admin/sub-subcategory/${id}/delete`, payload);
  return handleResponse(response, onSuccess, onError);
};

export const deleteSubSubcategory = (id, onSuccess, onError) => {
  const response = axios.delete(`v1/admin/sub-subcategory/${id}`);
  return handleResponse(response, onSuccess, onError);
};
